export const sliderDefaultProps = {
  min: 0,
  max: 100,
  step: 1,
  value: 0,
  error: false,
  disabled: false
};
export const rangeSliderDefaultProps = {
  min: 0,
  max: 100,
  step: 1,
  value: [0, 100],
  error: false,
  disabled: false
};